import React from "react";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import QualityCertification from "./QualityCertification";
import { Linkedin } from "lucide-react";

// Leadership Hero Component
const LeadershipHero = () => {
  return (
    <section className="abbleadership-hero">
      <div className="abbbcontainer">
        <h1>Visionary Leadership</h1>
        <p className="abbsubtitle">
          Meet the innovative minds driving ITSoftlab's growth and technological excellence
        </p>

        <div className="abbprofile-card">
          {/* Monika Ahirwal - CEO */}
          <div className="abbprofile-image">
            <div className="abbimage-placeholder">
              <img src="/images/m.jpeg" alt="Monika Ahirwal - Chief Executive Officer" />
            </div>

            <div className="abbprofile-info abbprofile-info-right">
              <h2>Monika Ahirwal</h2>
              <p className="abbprofile-role">Chief Executive Officer</p>
              <p>
                Monika Ahirwal is the dynamic CEO and visionary leader of IT Softlab. With over 15 years of experience in the business and technology sectors, Monika has built a reputation for her strategic thinking, leadership, and ability to drive growth. A post-graduate by education, she has applied her strong foundation in management to successfully lead a technology-driven company.
              </p>
              <p>
                Monika's unique perspective, combining a deep understanding of business operations with a focus on technology, has been instrumental in building IT Softlab into a global IT solutions provider. Her leadership style is marked by a customer-first mentality, innovation, and an unwavering commitment to delivering high-quality, scalable solutions for businesses of all sizes.
              </p>

              <div className="abbsocial-links">
                <a
                  href="https://www.linkedin.com/in/monika-ahirwal-14471232b/"
                  aria-label="Monika Ahirwal LinkedIn Profile"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Linkedin size={20} />
                </a>
              </div>
            </div>
          </div>

          {/* Rahul Ahirwal - MD & CTO */}
          <div className="abbprofile-image abbprofile-image-balanced">
            <div className="abbimage-placeholder">
              <img src="/images/rahulsir.jpeg" alt="Rahul Ahirwal - Managing Director & CTO" />
            </div>

            <div className="abbprofile-info abbprofile-info-left">
              <h2>Rahul Ahirwal</h2>
              <p className="abbprofile-role">Managing Director &amp; Chief Technical Officer</p>
              <p>
                Rahul Ahirwal spearheads the company's technology vision and innovation. With over 15 years of experience in the IT industry and an M.Tech from the Indian Institute of Technology Roorkee, he brings extensive expertise in Product Engineering, Cloud &amp; DevOps, SaaS Platforms, Artificial Intelligence and Machine Learning (AI/ML), Enterprise Systems, Cybersecurity, Technical Strategy, Digital Transformation, E-Governance Solutions, Innovation Leadership, and Large-Scale Government Projects. Throughout his career, he has successfully led the design, development, and delivery of enterprise-grade digital platforms for businesses, government organizations, and public sector institutions.
              </p>
              <p>
                At IT Softlab, he leads product architecture, engineering excellence, technology governance, and innovation programs, ensuring the delivery of secure, scalable, and future-ready solutions that help organizations improve efficiency, accelerate growth, and achieve long-term digital success.
              </p>

              <div className="abbsocial-links">
                <a
                  href="https://www.linkedin.com/in/rahul-ahirwal-a062a71a2/"
                  aria-label="Rahul Ahirwal LinkedIn Profile"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Linkedin size={20} />
                </a>
              </div>
            </div>
          </div>

          <div className="abbprofile-content">
            <Link to="/contactus" className="abbconnect-button">
              Connect with Us →
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default function AboutPage() {
  return (
    <>
      <Navbar />
      <main className="main">
        <div className="video-container">
          <video autoPlay loop muted playsInline>
            <source
              src="https://cdn.pixabay.com/video/2020/08/12/46965-449623750_large.mp4"
              type="video/mp4"
            />
          </video>
        </div>

        {/* Hero Section */}
        <section className="hero">
          <div className="containerrr">
            <div className="text-center">
              <h1 className="hero-title">About Us</h1>
              <p className="hero-subtitle">
                We specialize in end-to-end digital transformation solutions including custom software engineering, enterprise and government technology systems, AI-powered platforms, automation solutions, secure cloud and mobile applications, and scalable white-labeled digital products tailored to diverse industries and institutional needs.
              </p>
            </div>
          </div>
        </section>

        <div className="appppp">
          <LeadershipHero />
          <QualityCertification />
        </div>

        <div className="about-container">
          {/* Our Story Section */}
          <div className="our-story">
            <div className="story-text">
              <span className="story-eyebrow">Our Journey</span>
              <h2>Our Story</h2>
              <div className="story-divider" />
              <p>
                IT Softlab was born with a mission to address a critical gap in the market — affordable IT solutions for startups, MSMEs, and small businesses. Many of these businesses had innovative ideas and huge potential but faced difficulties finding the right IT support at an affordable cost.
              </p>
              <p>
                Starting with a small but dedicated team, we set out to provide scalable, reliable, and cost-effective IT solutions — helping businesses focus on growth while we handled their technology needs.
              </p>
              <div className="story-leaders">
                <div className="story-leader-card">
                  <span className="story-leader-icon">👩‍💼</span>
                  <div>
                    <strong>Monika Ahirwal</strong>
                    <span>CEO — 15+ years of experience guiding IT Softlab into a global IT powerhouse.</span>
                  </div>
                </div>
                <div className="story-leader-card">
                  <span className="story-leader-icon">👨‍💻</span>
                  <div>
                    <strong>Rahul Ahirwar</strong>
                    <span>MD &amp; CTO (IIT Roorkee) — leading innovation, AI platforms, and 360° digital transformation.</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="story-image">
              <img
                src="/images/slbpr.jpg"
                alt="IT Softlab at High Commission of Sri Lanka"
                className="story-img"
              />
            </div>
          </div>

          <div className="story-acknowledgement">
            <span className="story-ack-icon">🤝</span>
            <p>
              We are proud to have partnered with the <strong>High Commission of the Democratic Socialist Republic of Sri Lanka</strong> for the successful development, deployment, and handover of the SLBPR reservation management system.
            </p>
          </div>

          {/* Mission & Values */}
          <div className="mission-values">
            <div className="mv-header">
              <h2>Our Mission, Vision &amp; Values</h2>
              <p>
                Guided by our core principles, we strive to deliver innovative technology solutions that empower businesses to thrive in the digital age.
              </p>
            </div>

            <div className="mv-cards">
              <div className="mv-card">
                <div className="icon">🎯</div>
                <h3>Our Mission</h3>
                <p>
                  To be a globally trusted technology partner, delivering innovative, scalable, and sustainable digital solutions that enable businesses to achieve long-term success.
                </p>
              </div>

              <div className="mv-card">
                <div className="icon">💡</div>
                <h3>Our Vision</h3>
                <p>
                  To create high-quality, customized IT solutions by combining deep technical expertise with strategic insight—helping clients optimize operations, enhance efficiency, and gain a competitive advantage through technology.
                </p>
              </div>

              <div className="mv-card">
                <div className="icon">🏅</div>
                <h3>Our Values</h3>
                <p>
                  Excellence, integrity, innovation, collaboration, and client-centricity form the foundation of everything we do.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Core Strengths Section */}
        <div className="it-services">
          <div className="it-header">
            <h2>Our Core Strengths</h2>
            <p>Key skills and expertise that drive the company's success and deliver outstanding results.</p>
          </div>

          <div className="it-grid">
            <div className="it-card">
              <div className="it-icon">🔗</div>
              <h3>AI-powered Enterprise Solutions</h3>
              <p>Advanced enterprise solutions using artificial intelligence to automate processes and boost business efficiency.</p>
            </div>

            <div className="it-card">
              <div className="it-icon">🛡️</div>
              <h3>Customized CRM, ERP, and HR Platforms</h3>
              <p>Tailor-made CRM, ERP, and HR platforms designed to fit specific business needs and workflows.</p>
            </div>

            <div className="it-card">
              <div className="it-icon">☁️</div>
              <h3>Robust Cloud and Data Infrastructure</h3>
              <p>Strong and reliable cloud services and data infrastructure ensuring scalability, security, and high performance.</p>
            </div>

            <div className="it-card">
              <div className="it-icon">💻</div>
              <h3>Advanced Cybersecurity &amp; Disaster Recovery</h3>
              <p>Comprehensive cybersecurity measures and disaster recovery plans to protect data and ensure business continuity.</p>
            </div>

            <div className="it-card">
              <div className="it-icon">📈</div>
              <h3>Subscription-based Business Software</h3>
              <p>Software products offered on a subscription model, providing ongoing updates and support for businesses.</p>
            </div>

            <div className="it-card">
              <div className="it-icon">🛠️</div>
              <h3>Agile Web &amp; Mobile Application Development</h3>
              <p>Flexible and efficient development of websites and mobile apps using agile methodologies for quick delivery and adaptability.</p>
            </div>
          </div>
        </div>

        {/* Why Choose Us */}
        <div className="app">
          <section className="why-choose-us">
            <h2 className="title">Why Choose ITSoftlab</h2>
            <p className="subtitle">
              We differentiate ourselves through our commitment to excellence, innovation, and client satisfaction.
            </p>

            <div className="features-grid">
              <div className="feature">
                <span className="check">✓</span>
                <div>
                  <h3>360° IT Solution Provider</h3>
                  <p>Providing comprehensive product-based and service-based technology solutions from consulting and development to deployment, support, and digital transformation.</p>
                </div>
              </div>

              <div className="feature">
                <span className="check">✓</span>
                <div>
                  <h3>One Platform, Multiple Solutions</h3>
                  <p>Delivering CRM, ERP, HRMS, DMS, POS, Inventory, E-Commerce, Mobile Apps, and AI Solutions within a connected ecosystem.</p>
                </div>
              </div>

              <div className="feature">
                <span className="check">✓</span>
                <div>
                  <h3>End-to-End Project Delivery</h3>
                  <p>Managing the complete project lifecycle from requirement analysis, planning, design, development, testing, deployment, training, and maintenance to ensure seamless execution and long-term success.</p>
                </div>
              </div>

              <div className="feature">
                <span className="check">✓</span>
                <div>
                  <h3>Quality Assurance Excellence</h3>
                  <p>Ensuring reliable, secure, and high-performing solutions through rigorous testing and quality standards.</p>
                </div>
              </div>

              <div className="feature">
                <span className="check">✓</span>
                <div>
                  <h3>Smart Analytics &amp; Business Intelligence</h3>
                  <p>Turning data into actionable insights through dashboards, reporting, and predictive analytics.</p>
                </div>
              </div>

              <div className="feature">
                <span className="check">✓</span>
                <div>
                  <h3>Global Delivery Capability</h3>
                  <p>Serving clients across different regions with consistent quality and timely project execution.</p>
                </div>
              </div>
            </div>
          </section>
        </div>

        {/* Main Contact Section */}
        <section className="about-contact-section" aria-label="Official Contact Information">
          <div className="about-contact-container">
            <div className="about-contact-header">
              <span className="about-contact-eyebrow">Connect With Us</span>
              <h2 className="about-contact-title">Contact Information</h2>
              <p className="about-contact-subtitle">
                Visit our office, give us a call, or email our team for enterprise and business inquiries.
              </p>
            </div>
            <div className="about-contact-grid">
              <div className="about-contact-card">
                <strong>📍 Visit Us</strong>
                <span>
                  651, A Above Bandhan Bank,<br />
                  Mahalaxmi Nagar, Indore,<br />
                  Madhya Pradesh, India.
                </span>
                <a
                  href="https://maps.google.com/?q=651+A+Above+Bandhan+Bank+Mahalaxmi+Nagar+Indore+Madhya+Pradesh+India"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="about-contact-link about-contact-cta"
                >
                  View on Google Maps →
                </a>
              </div>
              <div className="about-contact-card">
                <strong>📞 Phone</strong>
                <a href="tel:9039607555" className="about-contact-link">
                  9039607555
                </a>
                <span className="about-contact-meta">Mon - Sat: 9:00 AM - 7:00 PM IST</span>
                <span className="about-contact-meta">Support &amp; Sales Inquiries</span>
                <a href="tel:9039607555" className="about-contact-link about-contact-cta">
                  Call our team →
                </a>
              </div>
              <div className="about-contact-card">
                <strong>✉ Email</strong>
                <a href="mailto:contact@itsoftlab.com" className="about-contact-link">
                  contact@itsoftlab.com
                </a>
                <span className="about-contact-meta">Quick response within 24 hours</span>
                <span className="about-contact-meta">Enterprise &amp; Franchise Inquiries</span>
                <a href="mailto:contact@itsoftlab.com" className="about-contact-link about-contact-cta">
                  Send an email →
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="ctxaa">
          <div className="contaiiiner">
            <h2 className="cta-titleex">Ready to Work With Us?</h2>
            <p className="cta-texxtt">
              Contact us today to learn more about our services and accelerate your digital transformation journey.
            </p>
            <Link to="/contactus">
              <button className="button">Contact Us</button>
            </Link>
          </div>
        </section>

        {/* ===== Footer ===== */}
        <footer className="footer">
          <div className="footer-container">
            {/* Brand */}
            <div className="footer-section footer-brand">
              <div className="footer-logo-wrap">
                <div className="footer-logo-img"></div>
              </div>
              <p>
                Empowering businesses with end-to-end 360° IT solutions,
                innovative digital products, and reliable technology services.
                We help organizations streamline operations, accelerate growth,
                and achieve digital transformation through cutting-edge software,
                web, mobile, cloud, and AI-driven solutions.
              </p>
              <p>
                Protect your data with top-notch cybersecurity measures. Awarded
                Best IT Company for consulting services and web development.
              </p>
            </div>

            {/* Quick Links */}
            <div className="footer-section">
              <h4>Quick Links</h4>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/aboutPage">About Us</Link></li>
                <li><Link to="/servicespage">Services</Link></li>
                <li><Link to="/careerpage">Careers</Link></li>
                <li><Link to="/contactus">Contact Us</Link></li>
                <li><Link to="/privacypage">Privacy Policy</Link></li>
                <li><Link to="/termpage">Terms &amp; Conditions</Link></li>
                <li><Link to="/products">Products</Link></li>
              </ul>
            </div>

            {/* Our Services */}
            <div className="footer-section">
              <h4>Our Services</h4>
              <ul>
                <li><Link to="/servicespage">Android / iOS App Development</Link></li>
                <li><Link to="/servicespage">Web App Development</Link></li>
                <li><Link to="/servicespage">Software Development</Link></li>
                <li><Link to="/servicespage">Cloud &amp; SaaS / PaaS / IaaS</Link></li>
                <li><Link to="/servicespage">Cyber Security</Link></li>
                <li><Link to="/servicespage">Disaster Recovery</Link></li>
                <li><Link to="/servicespage">AI / ML Solutions</Link></li>
                <li><Link to="/servicespage">DevOps &amp; Automation</Link></li>
              </ul>
            </div>

            {/* Our Products */}
            <div className="footer-section">
              <h4>Our Products</h4>
              <ul>
                <li><Link to="/crm">CRM</Link></li>
                <li><a href="https://hrmsm.com/home" target="_blank" rel="noopener noreferrer">HRMS</a></li>
                <li><Link to="/contactus">VMS</Link></li>
                <li><Link to="/contactus">ERP</Link></li>
                <li><Link to="/contactus">DMS</Link></li>
                <li><Link to="/contactus">LMS</Link></li>
                <li><Link to="/contactus">POS</Link></li>
                <li><Link to="/contactus">Marketing Automation</Link></li>
              </ul>
            </div>
          </div>

          <hr className="footer-hr" />
          <p className="footer-bottom">© 2026 IT SOFTLAB. All rights reserved.</p>
        </footer>
      </main>

      <style>
        {`
/* ==========================================================================
   ABOUT US PAGE - FULL RESPONSIVE STYLES
   ========================================================================== */

.abbbcontainer {
  max-width: 1200px;
  width: 100%;
  box-sizing: border-box;
  margin: 0 auto;
}

.video-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: -1;
}

.video-container video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.containerrr {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
}

.text-center {
  text-align: center;
}

/* Hero Section */
.hero {
  color: white;
  margin-top: 60px;
  padding: clamp(90px, 14vw, 150px) clamp(16px, 4vw, 24px) clamp(40px, 6vw, 60px);
  text-align: center;
  position: relative;
  z-index: 2;
  box-sizing: border-box;
}

.hero-title {
  font-size: clamp(2.2rem, 6vw, 48px);
  font-weight: 800;
  margin-bottom: 16px;
  letter-spacing: -0.02em;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.4);
}

.hero-subtitle {
  font-size: clamp(0.95rem, 2.5vw, 1.15rem);
  line-height: 1.7;
  max-width: 1000px;
  margin: 0 auto;
  color: rgba(255, 255, 255, 0.95);
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.3);
}

/* App Wrapper */
.appppp {
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  min-height: auto;
}

/* Leadership Hero */
.abbleadership-hero {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: clamp(40px, 6vw, 60px) clamp(16px, 4vw, 24px);
  box-sizing: border-box;
  width: 100%;
}

.abbleadership-hero h1 {
  font-size: clamp(2rem, 5.5vw, 3rem);
  font-weight: 800;
  text-align: center;
  color: #ffffff;
  margin-bottom: 12px;
  line-height: 1.15;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.4);
}

.abbsubtitle {
  font-size: clamp(0.95rem, 2.5vw, 1.2rem);
  color: rgba(255, 255, 255, 0.9);
  max-width: 750px;
  text-align: center;
  margin: 0 auto clamp(24px, 4vw, 40px);
  line-height: 1.6;
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.3);
}

.abbprofile-card {
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.15);
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  width: 100%;
  box-sizing: border-box;
  margin-left: auto;
  margin-right: auto;
  gap: clamp(18px, 3vw, 28px);
  padding: clamp(16px, 3vw, 28px);
}

.abbprofile-image {
  display: flex;
  position: relative;
  border-radius: 14px;
  overflow: hidden;
  background: #0f2744;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.1);
}

.abbimage-placeholder {
  flex: 0 0 38%;
  min-height: 480px;
  height: auto;
  position: relative;
  z-index: 2;
  overflow: hidden;
  background-color: #0f172a;
}

.abbimage-placeholder img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
  transition: transform 0.35s ease;
  display: block;
}

.abbimage-placeholder:hover img {
  transform: scale(1.03);
}

.abbprofile-image-balanced .abbimage-placeholder {
  height: auto;
  min-height: 480px;
}

.abbprofile-info {
  flex: 1;
  padding: clamp(24px, 3.5vw, 40px);
  background: linear-gradient(135deg, rgba(23, 47, 85, 0.98) 0%, rgba(15, 34, 64, 0.98) 100%);
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  box-sizing: border-box;
}

.abbprofile-info h2 {
  font-size: clamp(1.6rem, 3.5vw, 2.3rem);
  font-weight: 700;
  margin-bottom: 6px;
  color: #ffffff;
  line-height: 1.2;
}

.abbprofile-role {
  font-size: clamp(0.95rem, 2.2vw, 1.1rem);
  font-weight: 600;
  color: #38bdf8 !important;
  margin-bottom: 14px !important;
  letter-spacing: 0.3px;
}

.abbprofile-info p {
  font-size: clamp(0.9rem, 2.2vw, 0.98rem);
  color: #e2e8f0;
  line-height: 1.7;
  margin-bottom: 14px;
  text-align: left;
}

.abbprofile-info p:last-of-type {
  margin-bottom: 20px;
}

.abbsocial-links {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-top: 4px;
}

.abbsocial-links a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  min-width: 44px;
  min-height: 44px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.12);
  color: white;
  transition: all 0.2s ease;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.abbsocial-links a:hover {
  background-color: #38bdf8;
  color: #0f172a;
  transform: translateY(-2px);
}

.abbprofile-content {
  padding: 8px 0;
  display: flex;
  position: relative;
  z-index: 2;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.abbconnect-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: min(340px, 100%);
  padding: 14px 28px;
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  color: #ffffff;
  text-align: center;
  font-weight: 700;
  font-size: 1rem;
  border-radius: 8px;
  text-decoration: none;
  transition: all 0.25s ease;
  box-shadow: 0 4px 14px rgba(37, 99, 235, 0.35);
  min-height: 48px;
  box-sizing: border-box;
}

.abbconnect-button:hover {
  background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
  color: #ffffff;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(37, 99, 235, 0.45);
}

/* Mobile & Tablet Leadership Layout */
@media (max-width: 860px) {
  .abbprofile-image {
    flex-direction: column !important;
  }
  .abbimage-placeholder,
  .abbprofile-image-balanced .abbimage-placeholder {
    flex: none;
    width: 100%;
    min-height: unset;
    height: clamp(260px, 60vw, 360px);
  }
  .abbprofile-info {
    padding: clamp(20px, 4vw, 28px);
    text-align: left;
  }
  .abbprofile-info p {
    text-align: left;
    font-size: clamp(0.92rem, 2.5vw, 1rem);
    line-height: 1.65;
  }
}

/* ==========================================================================
   OUR STORY SECTION
   ========================================================================== */
.about-container {
  padding: clamp(36px, 6vw, 70px) clamp(16px, 4vw, 24px);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #222;
  max-width: 1240px;
  margin: 30px auto 0;
  position: relative;
  background: #f8fafc;
  z-index: 2;
  border-radius: 20px;
  box-sizing: border-box;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
}

.our-story {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: clamp(28px, 4vw, 56px);
  align-items: center;
  margin-bottom: 28px;
}

.story-eyebrow {
  display: inline-block;
  background: #eff6ff;
  color: #2563eb;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  padding: 6px 16px;
  border-radius: 20px;
  margin-bottom: 12px;
  width: fit-content;
}

.story-text h2 {
  font-size: clamp(1.75rem, 5vw, 36px);
  margin: 0 0 12px;
  color: #004080;
  font-weight: 800;
  line-height: 1.2;
}

.story-divider {
  width: 50px;
  height: 4px;
  background: linear-gradient(to right, #004080, #2563eb);
  border-radius: 4px;
  margin-bottom: 18px;
}

.story-text p {
  font-size: clamp(0.92rem, 2.3vw, 15.5px);
  line-height: 1.75;
  margin-bottom: 14px;
  color: #475569;
}

.story-leaders {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
}

.story-leader-card {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: clamp(14px, 2.5vw, 16px) clamp(14px, 2.5vw, 18px);
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
  box-sizing: border-box;
}

.story-leader-card:hover {
  box-shadow: 0 4px 16px rgba(37,99,235,0.1);
  border-color: #93c5fd;
}

.story-leader-icon {
  font-size: 26px;
  flex-shrink: 0;
  margin-top: 2px;
}

.story-leader-card strong {
  display: block;
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 3px;
}

.story-leader-card span {
  font-size: clamp(12.5px, 2.2vw, 13.5px);
  color: #64748b;
  line-height: 1.55;
}

.story-image {
  position: relative;
  width: 100%;
}

.story-img {
  width: 100%;
  height: auto;
  aspect-ratio: 16/10;
  max-height: 420px;
  object-fit: cover;
  border-radius: 16px;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.12);
  display: block;
}

.story-acknowledgement {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  background: #eff6ff;
  border-left: 4px solid #2563eb;
  border-radius: 0 12px 12px 0;
  padding: clamp(14px, 2.5vw, 18px) clamp(14px, 2.5vw, 20px);
  margin-bottom: 36px;
  box-sizing: border-box;
}

.story-ack-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  min-width: 38px;
  background: #dbeafe;
  border-radius: 8px;
  font-size: 18px;
  flex-shrink: 0;
}

.story-acknowledgement p {
  margin: 0;
  font-size: clamp(0.9rem, 2.3vw, 14.5px);
  line-height: 1.7;
  color: #1e3a8a;
}

@media (max-width: 900px) {
  .our-story {
    grid-template-columns: 1fr;
    gap: 28px;
  }
  .story-img {
    max-height: 300px;
  }
}

/* ==========================================================================
   MISSION, VISION & VALUES
   ========================================================================== */
.mission-values {
  background-color: #ffffff;
  padding: clamp(32px, 5vw, 50px) clamp(16px, 4vw, 32px);
  border-radius: 16px;
  margin-top: 20px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
  box-sizing: border-box;
}

.mv-header {
  text-align: center;
  margin-bottom: clamp(24px, 4vw, 40px);
}

.mv-header h2 {
  font-size: clamp(1.6rem, 4.5vw, 32px);
  margin-bottom: 10px;
  color: #003366;
  font-weight: 800;
}

.mv-header p {
  font-size: clamp(0.92rem, 2.3vw, 15.5px);
  color: #64748b;
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
}

.mv-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: clamp(16px, 3vw, 24px);
  box-sizing: border-box;
  width: 100%;
}

.mv-card {
  background-color: #f8fafc;
  padding: clamp(20px, 3vw, 28px) clamp(16px, 3vw, 24px);
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  text-align: center;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.mv-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 24px rgba(37, 99, 235, 0.1);
  border-color: #bfdbfe;
}

.mv-card .icon {
  font-size: 36px;
  margin-bottom: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 14px;
  background: #eff6ff;
}

.mv-card h3 {
  font-size: clamp(1.15rem, 2.5vw, 1.3rem);
  color: #003366;
  margin-bottom: 10px;
  font-weight: 700;
}

.mv-card p {
  font-size: clamp(0.88rem, 2.2vw, 0.95rem);
  color: #475569;
  line-height: 1.65;
  margin: 0;
}

@media (max-width: 860px) {
  .mv-cards {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .mv-card {
    width: 100%;
    max-width: 100%;
  }
}

/* ==========================================================================
   OUR CORE STRENGTHS
   ========================================================================== */
.it-services {
  max-width: 1240px;
  margin: clamp(40px, 6vw, 70px) auto;
  padding: 0 clamp(16px, 4vw, 24px);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  text-align: center;
  box-sizing: border-box;
  position: relative;
  z-index: 2;
}

.it-header h2 {
  font-size: clamp(1.8rem, 5vw, 34px);
  margin-bottom: 12px;
  color: #ffffff;
  font-weight: 800;
  letter-spacing: -0.01em;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.4);
}

.it-header p {
  font-size: clamp(0.95rem, 2.5vw, 16px);
  color: rgba(255, 255, 255, 0.9);
  max-width: 800px;
  margin: 0 auto clamp(24px, 4vw, 40px);
  line-height: 1.6;
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.3);
}

.it-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: clamp(16px, 2.5vw, 24px);
  width: 100%;
  box-sizing: border-box;
}

.it-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(226, 232, 240, 0.8);
  border-radius: 14px;
  padding: clamp(20px, 3vw, 28px) clamp(16px, 3vw, 22px);
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  text-align: left;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.it-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 14px 30px rgba(15, 23, 42, 0.12);
  border-color: #bfdbfe;
}

.it-icon {
  font-size: 30px;
  margin-bottom: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: #eff6ff;
}

.it-card h3 {
  font-size: clamp(1.05rem, 2.4vw, 1.2rem);
  font-weight: 700;
  margin-bottom: 8px;
  color: #0f172a;
  line-height: 1.35;
}

.it-card p {
  font-size: clamp(0.88rem, 2.2vw, 0.95rem);
  color: #475569;
  line-height: 1.6;
  margin: 0;
}

@media (max-width: 992px) {
  .it-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 18px;
  }
}

@media (max-width: 600px) {
  .it-grid {
    grid-template-columns: 1fr;
    gap: 14px;
  }
  .it-card {
    width: 100%;
    padding: 18px 16px;
  }
}

/* ==========================================================================
   WHY CHOOSE US SECTION
   ========================================================================== */
.app {
  font-family: -apple-system, system-ui, sans-serif;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 52%, #ffffff 100%);
  padding: clamp(48px, 7vw, 86px) clamp(16px, 4vw, 24px);
  position: relative;
  z-index: 2;
  color: #0f172a;
  box-sizing: border-box;
}

.why-choose-us {
  max-width: 1240px;
  margin: 0 auto;
  box-sizing: border-box;
}

.title {
  text-align: center;
  font-size: clamp(1.8rem, 5vw, 48px);
  line-height: 1.15;
  font-weight: 800;
  color: #0f172a;
  margin: 0 0 14px;
  letter-spacing: -0.01em;
}

.subtitle {
  text-align: center;
  color: #64748b;
  max-width: 800px;
  margin: 0 auto clamp(24px, 4vw, 44px);
  line-height: 1.65;
  font-size: clamp(0.95rem, 2.4vw, 17px);
}

.features-grid {
  display: grid;
  gap: clamp(14px, 2.5vw, 22px);
  grid-template-columns: 1fr;
  width: 100%;
  box-sizing: border-box;
}

@media (min-width: 768px) {
  .features-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.feature {
  position: relative;
  display: flex;
  gap: 16px;
  padding: clamp(16px, 3vw, 24px);
  background: rgba(255, 255, 255, 0.85);
  border: 1px solid #edf2f7;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
  overflow: hidden;
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
  box-sizing: border-box;
  align-items: flex-start;
}

.feature::before {
  content: "";
  position: absolute;
  inset: 0 auto 0 0;
  width: 4px;
  background: #3b82f6;
  transform: scaleY(0);
  transform-origin: bottom;
  transition: transform 0.25s ease;
}

.feature:hover {
  transform: translateY(-4px);
  border-color: #dbeafe;
  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.08);
}

.feature:hover::before {
  transform: scaleY(1);
}

.check {
  background: #eff6ff;
  color: #2563eb;
  width: 36px;
  height: 36px;
  min-width: 36px;
  min-height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-weight: 900;
  border: 1px solid #dbeafe;
  font-size: 16px;
}

.feature h3 {
  margin: 0 0 6px;
  font-size: clamp(1rem, 2.5vw, 1.15rem);
  line-height: 1.3;
  color: #0f172a;
  font-weight: 700;
}

.feature p {
  margin: 0;
  color: #64748b;
  line-height: 1.6;
  font-size: clamp(0.88rem, 2.2vw, 0.95rem);
}

/* ==========================================================================
   ABOUT US - MAIN CONTACT SECTION
   ========================================================================== */
.about-contact-section {
  position: relative;
  z-index: 2;
  max-width: 1240px;
  margin: clamp(40px, 6vw, 64px) auto;
  padding: 0 clamp(16px, 3.5vw, 24px);
  box-sizing: border-box;
}

.about-contact-container {
  width: 100%;
  box-sizing: border-box;
}

.about-contact-header {
  text-align: center;
  margin-bottom: clamp(24px, 4vw, 36px);
}

.about-contact-eyebrow {
  display: inline-block;
  color: #38bdf8;
  font-size: clamp(12px, 2vw, 13px);
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  margin-bottom: 8px;
}

.about-contact-title {
  color: #ffffff;
  font-size: clamp(24px, 4.5vw, 34px);
  font-weight: 800;
  margin: 0 0 10px;
  letter-spacing: -0.02em;
}

.about-contact-subtitle {
  color: rgba(226, 232, 240, 0.85);
  font-size: clamp(13.5px, 2.2vw, 15px);
  max-width: 580px;
  margin: 0 auto;
  line-height: 1.6;
}

.about-contact-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: clamp(14px, 2.5vw, 20px);
  box-sizing: border-box;
}

.about-contact-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: clamp(18px, 3vw, 24px);
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 12px;
  background: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.about-contact-card strong {
  color: #f1f5f9;
  font-size: clamp(13px, 2.2vw, 14.5px);
  font-weight: 600;
  letter-spacing: 0.3px;
}

.about-contact-card span {
  color: #7dd3fc;
  font-size: clamp(13px, 2.4vw, 14.5px);
  font-weight: 500;
  word-break: break-word;
  line-height: 1.5;
}

.about-contact-card:hover {
  transform: translateY(-3px);
  border-color: #38bdf8;
  background: rgba(15, 23, 42, 0.75);
  box-shadow: 0 10px 28px rgba(2, 132, 199, 0.15);
}

.about-contact-link {
  color: #7dd3fc;
  font-size: clamp(13px, 2.4vw, 14.5px);
  font-weight: 600;
  text-decoration: none;
  transition: color 0.2s ease;
  word-break: break-word;
}

.about-contact-link:hover {
  color: #ffffff;
  text-decoration: underline;
}

.about-contact-meta {
  color: rgba(226, 232, 240, 0.75);
  font-size: clamp(11.5px, 2.1vw, 12.5px);
  font-weight: 400;
  line-height: 1.4;
}

.about-contact-cta {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
  color: #38bdf8;
  font-size: clamp(12px, 2.2vw, 13px);
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s ease;
}

.about-contact-cta:hover {
  color: #ffffff;
  transform: translateX(2px);
  text-decoration: underline;
}

@media (max-width: 900px) {
  .about-contact-grid {
    grid-template-columns: 1fr;
    gap: 14px;
  }
}

/* ==========================================================================
   CTA SECTION
   ========================================================================== */
.ctxaa {
  color: #ffffff;
  background: linear-gradient(135deg, #0284c7 0%, #1e3a8a 100%);
  padding: clamp(40px, 6vw, 64px) clamp(16px, 4vw, 24px);
  text-align: center;
  border: none;
  position: relative;
  z-index: 2;
  box-sizing: border-box;
  width: 100%;
}

.contaiiiner {
  max-width: 800px;
  margin: 0 auto;
  box-sizing: border-box;
}

.cta-titleex {
  font-size: clamp(1.6rem, 4.5vw, 2.25rem);
  font-weight: 800;
  color: #ffffff;
  margin: 0 0 10px;
  letter-spacing: -0.01em;
}

.cta-texxtt {
  font-size: clamp(0.95rem, 2.4vw, 1.1rem);
  color: rgba(255, 255, 255, 0.9);
  max-width: 600px;
  margin: 0 auto 24px;
  line-height: 1.6;
}

.button {
  background-color: #ffffff;
  color: #1e3a8a;
  padding: 12px 32px;
  font-size: 1rem;
  font-weight: 700;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  transition: all 0.25s ease;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
}

.button:hover {
  background-color: #f0f6ff;
  color: #1d4ed8;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}

/* ==========================================================================
   FOOTER STYLES
   ========================================================================== */
.footer {
  position: relative;
  z-index: 2;
  background: linear-gradient(135deg, #07111f 0%, #0f172a 50%, #082f49 100%);
  color: #f8fafc;
  padding: clamp(48px, 8vw, 80px) clamp(16px, 4vw, 40px) clamp(24px, 4vw, 32px);
  font-family: "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, sans-serif;
  overflow: hidden;
  box-sizing: border-box;
  width: 100%;
}

.footer::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(148, 163, 184, 0.06) 1px, transparent 1px),
    linear-gradient(90deg, rgba(148, 163, 184, 0.06) 1px, transparent 1px);
  background-size: 42px 42px;
  pointer-events: none;
}

.footer::after {
  content: "";
  position: absolute;
  width: min(420px, 80vw);
  height: min(420px, 80vw);
  right: -140px;
  top: -180px;
  background: radial-gradient(circle, rgba(56, 189, 248, 0.18), transparent 68%);
  pointer-events: none;
}

.footer-container {
  position: relative;
  z-index: 1;
  max-width: 1280px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 2fr 1fr 1.2fr 1.2fr;
  gap: clamp(24px, 4vw, 48px);
  align-items: start;
  padding-bottom: clamp(32px, 5vw, 48px);
  box-sizing: border-box;
}

.footer-section {
  min-width: 0;
}

.footer-brand {
  padding: clamp(20px, 3vw, 28px) clamp(16px, 3vw, 32px);
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  box-shadow: 0 16px 40px rgba(2, 6, 23, 0.2);
  position: relative;
  box-sizing: border-box;
}

.footer-brand::before {
  content: "";
  position: absolute;
  left: 0;
  top: 24px;
  bottom: 24px;
  width: 3px;
  border-radius: 999px;
  background: linear-gradient(to bottom, #38bdf8, #2563eb);
}

.footer-logo-wrap {
  margin-bottom: 16px;
}

.footer-logo-img {
  height: 48px;
  width: 190px;
  max-width: 100%;
  background-image: url("/images/log.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left center;
  filter: brightness(0) saturate(100%) invert(27%) sepia(98%) saturate(1200%) hue-rotate(210deg) brightness(95%);
}

.footer-brand p {
  color: #cbd5e1;
  font-size: clamp(13px, 2.2vw, 14.5px);
  line-height: 1.8;
  margin: 0 0 12px;
}

.footer-brand p:last-child {
  margin-bottom: 0;
}

.footer-section h3,
.footer-section h4 {
  margin: 0 0 18px;
  color: #ffffff;
  font-size: clamp(15px, 2.5vw, 17px);
  font-weight: 700;
  letter-spacing: 0.3px;
}

.footer-section h4 {
  position: relative;
  padding-bottom: 12px;
}

.footer-section h4::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 36px;
  height: 2px;
  border-radius: 999px;
  background: linear-gradient(to right, #38bdf8, #2563eb);
}

.footer-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.footer-section li {
  line-height: 1;
}

.footer-section p,
.footer-section li,
.footer-section a {
  color: #94a3b8;
  font-size: clamp(13px, 2.2vw, 14px);
  line-height: 1.6;
}

.footer-section a {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  transition: color 0.2s ease, transform 0.2s ease;
  padding: 4px 0;
  min-height: 32px;
}

.footer-section a::before {
  content: "";
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: rgba(56, 189, 248, 0.6);
  flex-shrink: 0;
  transition: transform 0.2s ease, background 0.2s ease;
}

.footer-section a:hover {
  color: #ffffff;
  transform: translateX(4px);
}

.footer-section a:hover::before {
  background: #38bdf8;
  transform: scale(1.4);
}

.footer-hr {
  position: relative;
  z-index: 1;
  max-width: 1280px;
  margin: 0 auto clamp(16px, 3vw, 20px);
  border: 0;
  border-top: 1px solid rgba(148, 163, 184, 0.18);
}

.footer-bottom {
  position: relative;
  z-index: 1;
  text-align: center;
  margin: 0;
  color: #64748b;
  font-size: clamp(12px, 2.2vw, 13.5px);
}

@media (max-width: 1100px) {
  .footer-container {
    grid-template-columns: 1fr 1fr;
    gap: 32px;
  }
}

@media (max-width: 768px) {
  .footer-container {
    grid-template-columns: 1fr;
    gap: 28px;
  }
}
        `}
      </style>
    </>
  );
}
